export enum UserPermission {
    Admin = 'Admin',
    Student = 'Student',
    TrainingCenter = 'TrainingCenter',
    Instructor = 'Instructor',
}
